






























import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import api from "../store/api";
import { IAccountDetails } from "../store/main.interfaces";
import { createEmptyUserObject } from "../store/user.util";
import { TranslateResult } from "vue-i18n";
import user, { userHasRole, userHasPrivilege } from "../store/modules/user";

@Component
export default class AccountCreationForm extends Vue {
  @Prop() editableUserObject!: IAccountDetails;
  @Prop() optionalPassword!: boolean;
  @Prop() privilegeRestriction!: string;
  roleArray: string[] = ["USER", "ADMIN", "ORG_MANAGER"];
  dialog: boolean = false;
  dialogText: string | TranslateResult = "";
  async saveAccount() {
    if (this.editableUserObject.roles.indexOf("ACCESS") === -1) {
      this.editableUserObject.roles.push("ACCESS");
    }
    this.$emit("accountSaveEvent", this.editableUserObject);
  }

  getPasswordText() {
    if (this.optionalPassword === true) {
      return this.$t("generics.terms.optional.password");
    } else {
      return this.$t("generics.terms.password");
    }
  }

  hasPrivilege(restriction: string) {
    return userHasPrivilege(restriction);
  }
}
